import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from './analytics';

const YOUTUBE_VIDEO_ID = 'videoseries?si=t5yy8LVRjH9qKnKm&list=OLAK5uy_nnz5zKudUtncqbfaIQZtX1NeKP6TUHJAg';

function EmptyBattery() {
    return (
        <div className="charging-battery" aria-label="Empty battery">
            <div className="battery-body">
                <div className="battery-fill" style={{ width: '4%' }} />
                <span className="battery-pct">0%</span>
            </div>
            <div className="battery-tip" />
        </div>
    );
}

export default function ChargingPage() {
    const [searching, setSearching] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [embedOpacity, setEmbedOpacity] = React.useState(0.2);

    React.useEffect(() => {
        trackEvent('page_view', 'charging');
    }, []);

    const findGasStation = () => {
        setSearching(true);
        setError(null);

        if (!navigator.geolocation) {
            // Fallback: open Google Maps gas station search without location
            window.open('https://www.google.com/maps/search/gas+station+near+me', '_blank');
            setSearching(false);
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (pos) => {
                const { latitude, longitude } = pos.coords;
                trackEvent('gas_station_search', 'with_location');
                const url = `https://www.google.com/maps/search/gas+station/@${latitude},${longitude},15z`;
                window.open(url, '_blank');
                setSearching(false);
            },
            () => {
                // Permission denied or unavailable — fall back to generic search
                trackEvent('gas_station_search', 'fallback');
                window.open('https://www.google.com/maps/search/gas+station+near+me', '_blank');
                setSearching(false);
            },
            { timeout: 8000 }
        );
    };

    const ytSrc =
        `https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}` +
        `&autoplay=1&mute=1&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`;

    return (
        <div className="loc-page fade-in">
            {/* Back nav */}
            <div className="nav-header">
                <Link to="/" className="back-link">← Back</Link>
            </div>

            {/* Hero */}
            <section className="loc-hero charging-hero">
                <EmptyBattery />
                <h1 className="loc-title charging-title">
                    Uh oh. 🪫
                </h1>
                <p className="charging-sorry">
                    Sorry, looks like you're running on empty.
                </p>
                <p className="loc-subtitle">
                    No worries — we'll help you find the nearest place to fuel up.
                </p>
            </section>

            {/* CTA */}
            <section className="charging-cta-section">
                <div className="charging-card">
                    <p className="charging-card-label">⛽ Need a charge?</p>
                    <p className="charging-card-body">
                        Tap below and we'll pull up the closest gas station to your current location.
                    </p>
                    <button
                        className="charging-find-btn"
                        onClick={findGasStation}
                        disabled={searching}
                    >
                        {searching ? 'Locating…' : '📍 Find Nearest Gas Station'}
                    </button>
                    {error && <p className="charging-error">{error}</p>}
                </div>
            </section>


            {/* YouTube Embed Section */}
            <section className="loc-embed-section fade-in">
                <div className="loc-embed-label">Now Playing: MELTDOWN Playlist</div>

                <div className="loc-opacity-controls">
                    <label htmlFor="opacity-slider-charging">Video Opacity: {Math.round(embedOpacity * 100)}%</label>
                    <input
                        id="opacity-slider-charging"
                        type="range"
                        min="0"
                        max="1"
                        step="0.01"
                        value={embedOpacity}
                        onChange={(e) => setEmbedOpacity(parseFloat(e.target.value))}
                        className="loc-opacity-slider"
                    />
                </div>

                <div className="loc-embed-frame" style={{ opacity: embedOpacity }}>
                    <iframe
                        width="100%"
                        height="450"
                        src={ytSrc}
                        title="YouTube playlist player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                </div>
            </section>

        </div>
    );
}
